@if (activeNoteItem(); as note) {
  <lib-ffd-note
    [note]="note"
    [searchTerm]="searchTerm()"
    [inEditMode]="note.id === editedNoteId()"
    [isNoteSaving]="isNoteSaving()"
    [isNoteSaved]="isNoteSaved()"
    (editNote)="onToggleEditMode(note)"
    (cancelEditMode)="onToggleEditMode(note)"
    (noteSave)="onNoteSave($event)"
    (deleteNote)="onDeleteNote($event)"
  />
}
